import { Component, Input } from '@angular/core';

import { statusProjetadoGanho } from '../../cliente-analise-mercado-status-projetado';
import { ClienteAnaliseMercadoStatusProjetadoPipe } from '../../pipes';

@Component({
    selector: 'sgt-cliente-analise-mercado-status-projetado-badge-pill-ganho',
    templateUrl: './cliente-analise-mercado-status-projetado-badge-pill-ganho.component.html',
    styleUrls: ['./cliente-analise-mercado-status-projetado-badge-pill-ganho.component.less']
})
export class ClienteAnaliseMercadoStatusProjetadoBadgePillGanhoComponent {
    /** Title para exibir no badge */
    @Input() title: string = null;

    constructor(private clienteAnaliseMercadoStatusProjetadoPipe: ClienteAnaliseMercadoStatusProjetadoPipe) { }

    /** Retorna o title para exibir no badge */
    getTitle(): string {
        return this.title ? this.title : this.clienteAnaliseMercadoStatusProjetadoPipe.transform(statusProjetadoGanho.id);
    }
}
